import React, { useEffect, useState } from 'react';
import AppShell from '../components/AppShell';
import RemetenteSection from '../components/settings/RemetenteSection';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { atualizarPerfil } from '../lib/api';

const PerfilPage = () => {
  const { user, refreshUser } = useAuth();
  const [nome, setNome] = useState('');
  const [fone, setFone] = useState('');
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) { setNome(user.name || ''); setFone(user.phone || ''); }
  }, [user]);

  const salvar = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try {
      await atualizarPerfil({ name: nome, phone: fone || null });
      await refreshUser();
      setMsg({ ok: true, text: 'Dados atualizados.' });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setMsg({ ok: false, text: typeof d === 'string' ? d : 'Confira o nome e o telefone.' });
    } finally { setBusy(false); }
  };

  return (
    <AppShell title="Meu perfil" subtitle="Atualize seus dados, sua logo e o endereço de remetente">
      <section className="bg-white rounded-2xl border border-slate-100 p-6 max-w-2xl mb-6">
        <h2 className="text-lg font-semibold text-slate-900 mb-4">Minha conta</h2>
        <form onSubmit={salvar} className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Nome *</span>
              <Input className="mt-1" value={nome} onChange={(e) => setNome(e.target.value)} maxLength={60} required />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Telefone (com DDD)</span>
              <Input className="mt-1" inputMode="tel" value={fone} onChange={(e) => setFone(e.target.value)} placeholder="(85) 99999-9999" />
            </label>
          </div>
          <label className="block">
            <span className="text-sm font-medium text-slate-700">E-mail</span>
            <Input className="mt-1 bg-slate-50 text-slate-500" value={user?.email || ''} readOnly />
            <span className="block text-xs text-slate-500 mt-1">O e-mail é o seu login e não pode ser alterado por aqui.</span>
          </label>
          {msg && <p className={`text-sm ${msg.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msg.text}</p>}
          <Button type="submit" disabled={busy} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
        </form>
      </section>
      <RemetenteSection />
    </AppShell>
  );
};

export default PerfilPage;
